import React from 'react'

const InputWithLabel = ({id, label, value, type, onInputChange}) => (
        <>
            <label htmlFor={id}>{label}:</label>
            &nbsp;
            <input id={id} type={type} value={value} autoComplete="off" onChange={onInputChange}/>
        </>
    );



export default InputWithLabel;
